var GetJobBySessionIdDto = /** @class */ (function () {
    function GetJobBySessionIdDto(data) {
        this.resultVideoId = data.resultVideoId;
        this.thumbUrl = data.thumbUrl;
        this.previewUrl = data.previewUrl;
        this.audio = data.audio;
        this.font = data.font;
        this.themeId = data.themeId;
        this.sources = data.sources;
        this.fileName = data.fileName;
        this.syndicationCallbackUrl = data.syndicationCallbackUrl;
        this.streamUrl = data.streamUrl;
        this.downloadUrl = data.downloadUrl;
        this.orientation = data.orientation;
        this.primaryColor = data.primaryColor;
        this.secondaryColor = data.secondaryColor;
    }
    return GetJobBySessionIdDto;
}());
export { GetJobBySessionIdDto };
//# sourceMappingURL=GetJobBySessionIdDto.js.map